<template>
  <div :class="[ 'dashboard', { loading: isLoading } ]">
    <div v-if="isLoading" class="row loading">
      <div class="col">
        <span class="spinner-border spinner-border" role="status"></span>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12 col-lg-6">
        <h3>Prospective Clients</h3>
        <div class="row">
          <div class="col-md-6">
            <MetricTile
              link="/tours"
              :number="metrics.numTours"
              :icon="require('../assets/icons/search-home-white.svg')"
              title="Tour Requests"
              action="Schedule" 
            />
          </div>
          <div class="col-md-6 mt-lg-0 mt-md-0 mt-sm-3">
            <MetricTile
              link="/waitlist"
              :number="metrics.numWaitlist"
              :icon="require('../assets/icons/waitlist-white.svg')"
              title="Waiting List"
              action="View All" 
            />
          </div>
        </div>
      </div>
      <div class="col-md-6 pl-lg-5 d-flex flex-column">
        <div class="row">
          <div class="col pt-md-4 pt-lg-0 mt-lg-0 mt-md-0 mt-sm-5">
            <h3>Upcoming</h3>
          </div>
          <div class="col">
            <button v-if="metrics.upcomingEvents.length" class="btn btn-small float-right" v-on:click="openUpcomingEvents">View all</button>
          </div>
        </div>
        <div class="upcoming-events flex-fill">
          <router-link v-for="event in metrics.upcomingEvents" :key="event.id" :to="getLink(event)" class="row event">
            <div class="col-md-3">
              <Calendar :date="event.date" />
            </div>
            <div class="col-md-9 text-col">
              <div class="title">{{ event.title }}</div>
              <div class="text">{{ event.subTitle }}</div>
            </div>
          </router-link>
          <div v-if="!metrics.upcomingEvents.length" class="row" style="height: 100%;">
            <div class="col">
              <div class="empty">
                <p>There are currently no upcoming items</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 bottom">
        <div class="row">
          <div class="col">
            <h3>Recently Updated</h3>
          </div>
          <div class="col">
            <button v-if="metrics.recentUpdates.length" class="btn btn-small float-right" v-on:click="openRecentUpdates">View all</button>
          </div>
        </div>
        <div class="row">
          <div v-for="update in metrics.recentUpdates" :key="update.i" class="col-md-4  mb-sm-3">
            <router-link :to="getUpdateLink(update)" class="update">
              <div class="date">{{ getLongDate(update.date) }}</div>
              <div class="title">{{ update.title }}</div>
              <div class="text">{{ update.text }}</div>
              <div class="user">
                <div class="avatar">
                  <Avatar :name="update.user.name" />
                </div>
                <div class="name">{{ update.user.name }}</div>
              </div>
            </router-link>
          </div>
          <div v-if="!metrics.recentUpdates.length" class="col">
            <div class="empty">
              <p>There has been no updates this past month</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpcomingEvents :open="isShowingUpcomingEvents" :close="closeUpcomingEvents" />
    <RecentUpdates :open="isShowingRecentUpdates" :close="closeRecentUpdates" />
  </div>
</template>

<script>
import axios from "axios";
import MetricTile from "../components/MetricTile.vue";
import Calendar from "../components/Calendar.vue";
import Avatar from "../components/Avatar.vue";
import UpcomingEvents from "../components/UpcomingEvents.vue";
import RecentUpdates from "../components/RecentUpdates.vue";

export default {
  name: 'Dashboard',
  components: {
    MetricTile,
    Calendar,
    Avatar,
    UpcomingEvents,
    RecentUpdates,
  },
  data: function () {
    return {
      isLoading: true,
      isShowingUpcomingEvents: false,
      isShowingRecentUpdates: false,
      metrics: {
        numTours: 0,
        numWaitlist: 0,
        upcomingEvents: [],
        recentUpdates: [],
      }
    };
  },
  methods: {
    getLongDate: function (dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString('en-US', { weekdat: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', dayPeriod: 'short' });
    },
    openUpcomingEvents: function () {
      this.isShowingUpcomingEvents = true;
    },
    closeUpcomingEvents: function () {
      this.isShowingUpcomingEvents = false;
    },
    openRecentUpdates: function () {
      this.isShowingRecentUpdates = true;
    },
    closeRecentUpdates: function () {
      this.isShowingRecentUpdates = false;
    },
    getLink: function (event) {
      if (event.type == 'alert') {
        return `/alerts/${event.id}`;
      }
      else if (event.type == 'tour') {
        return `/tours/${event.id}`;
      }
      else {
        return `#`;
      }
    },
    getUpdateLink: function (update) {
      if (update.type == 'alert') {
        return `/alerts/${update.modelId}`;
      }
      else if (update.type == 'tour') {
        return `/tours/${update.modelId}`;
      }
      else if (update.type == 'waitlist') {
        return `/waitlist/${update.modelId}`;
      }
      else if (update.type == 'suite') {
        return `/suites/${update.modelId}`;
      }
      else {
        return `#`;
      }
    }
  },
  mounted: function () {
    axios.get('/api/dashboard/metrics/read')
      .then((response) => {
        if (response.data) {
          this.isLoading = false;
          this.metrics = response.data;
        }
      });
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.dashboard {
  padding-top: 3.4375rem;
  padding-bottom: 3.4375rem;
  min-height: 100%;

  &.loading {
    display: flex;
    align-items: stretch;
  }
}

div.row.loading {
  text-align: center;
  width: 100%;

  .col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

h3 {
  font-size: 0.875rem;
  color: #4A4A4A;
  font-weight: 500;
  line-height: calc(17 / 14);
  margin: 0 0 1.875rem;
}

button.btn-small {
  padding: 0;
  font-size: 0.875rem;
  color: var(--accentColor);
}

div.upcoming-events {
  a.event {
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
    position: relative;

    &:hover {
      text-decoration: none;

      &:after {
        right: -5px;
      }

      div.title {
        color: var(--accentColor);
      }
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: calc(50% - 4.325px);
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='5px' height='10px' viewBox='0 0 5 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EPath%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Dashboard' transform='translate(-1342.000000, -212.000000)'%3E%3Cg id='Group-9' transform='translate(912.000000, 125.000000)'%3E%3C/g%3E%3Cpolygon id='Path' fill='%23000000' transform='translate(1344.453982, 217.046018) rotate(-90.000000) translate(-1344.453982, -217.046018) ' points='1348.07999 214.546018 1344.45398 218.344242 1340.80799 214.565703 1340.12874 215.234994 1344.44399 219.546018 1348.77922 215.215309'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      height: 8.65px;
      width: 5px;
      transition: right 250ms;
    }

    &:last-child {
      div.text-col {
        &:after {
          display: none;
        }
      }
    }

    div.text-col {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      position: relative;

      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: -0.5rem;
        left: 15px;
        right: 15px;
        height: 1px;
        background-color: #EBEBEB;
      }
    }

    div.title {
      font-size: 1rem;
      color: #4A4A4A;
      line-height: calc(18 / 16);
      margin: 0 0 2px;
      transition: color 250ms;
    }

    div.text {
      font-size: 0.75rem;
      line-height: 2;
      color: rgba(#222222, 0.56);
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;  
      overflow: hidden;
    }
  }
}

div.bottom {
  padding-top: 3.75rem;
  margin-top: 4.375rem;
  position: relative;

  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    top: 0;
    background-color: #EBEBEB;
  }
}

a.update {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid #ECECEC;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
  border-radius: 4px;
  padding: 25px;
  transition: transform 250ms;

  &:hover {
    text-decoration: none;
    transform: translateY(-10px);

    div.title,
    div.text {
      color: var(--accentColor);
    }
  }

  div.date {
    font-size: 0.75rem;
    line-height: 2;
    color: rgba(#222222, 0.56);
    margin: 0 0 21px;
  }

  div.title {
    font-weight: 500;
    font-size: 0.875rem;
    line-height: calc(17 / 14);
    margin: 0 0 8px;
    color: #4A4A4A;
    transition: color 250ms;
  }

  div.text {
    font-size: 1.25rem;
    line-height: calc(23 / 20);
    color: #4A4A4A;
    transition: color 250ms;
  }

  div.user {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin-top: 28px;
    padding: 25px 0 0;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: -25px;
      right: -25px;
      height: 1px;
      background-color: #EBEBEB;
    }

    div.name {
      padding-left: 20px;
      font-size: 1rem;
      line-height: calc(18 / 16);
      color: #4A4A4A;
    }
  }
}

div.empty {
  background-color: #F7F7F7;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  height: 100%;

  p {
    margin: 0;
    max-width: 200px;
    font-size: 1rem;
    line-height: calc(18 / 16);
    color: rgba(#4A4A4A, 0.36);
    text-align: center;
  }
}
</style>